import ApiService from "../ApiService";
// &searchString=${searchString}

const PolicyShippinFee = {

    search(page, PerPage, searchShippin) {
        return ApiService.get(`/policy-schedule-range/search/by/?page=${page}&perPage=${PerPage}&searchString=${searchShippin}`)
    },

    creategetShippinFee(formData) {
        return ApiService.post("/policy-schedule-range", formData);
    },
    updategetShippinFee(id, formData) {
        return ApiService.put("/policy-schedule-range/" + id, formData);
    },
    deleteShippinFee(id) {
        return ApiService.post("/policy-schedule-range/remove", id)
    },
    searchShippinFee(name) {
        return ApiService.post(`/policy-schedule-range/searchby?name=${name}`)
    }
};

export default PolicyShippinFee;